/* Keep each collection-title word intact at the existing responsive title size. */
(() => {
  const initialized = new WeakSet();

  function initialize(scope) {
    const title = scope.querySelector('[data-oe-collection-title]');
    if (!title || initialized.has(title)) return;
    initialized.add(title);

    const context = document.createElement('canvas').getContext('2d');
    if (!context) return;
    let previousWidth = 0;

    function fit() {
      if (!title.isConnected) return;
      title.style.removeProperty('--oe-collection-title-fit-size');
      const style = getComputedStyle(title);
      const availableWidth = title.clientWidth;
      if (!availableWidth) return;

      const preferredSize = parseFloat(style.fontSize);
      context.font = `${style.fontStyle} ${style.fontWeight} ${preferredSize}px ${style.fontFamily}`;
      const words = title.textContent.trim().toLocaleUpperCase(document.documentElement.lang || 'de').split(/\s+/u);
      const longestWidth = Math.max(...words.map(word => context.measureText(word).width));

      if (longestWidth > availableWidth) {
        // One pixel of breathing room prevents rounding from pushing a word outside.
        const fittedSize = Math.floor(preferredSize * (availableWidth - 1) / longestWidth * 100) / 100;
        title.style.setProperty('--oe-collection-title-fit-size', `${fittedSize}px`);
      }
    }

    const observer = new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (Math.abs(width - previousWidth) < 0.1) return;
      previousWidth = width;
      fit();
    });
    observer.observe(title);
    fit();
    document.fonts.ready.then(() => {
      fit();
      title.dataset.oeCollectionTitleFit = 'ready';
    });
    document.fonts.addEventListener('loadingdone', fit);
    function unload(event) {
      if (!event.target.contains(title)) return;
      observer.disconnect();
      document.fonts.removeEventListener('loadingdone', fit);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
